import React from 'react';
import { Button } from '@uplift/ui-v2';
import { makeStyles } from 'tss-react/mui';
import { ArrowBackSharp } from '@mui/icons-material';

const useStyles = makeStyles()(() => ({
  label: {
    textTransform: 'uppercase',
    fontWeight: 'normal',
    fontSize: '13px',
    lineHeight: '22px',
    letterSpacing: '1px',
  },
}));

type ButtonWithArrowType = {
  label: string;
  onClick?: () => void;
  color?: 'inherit' | 'primary' | 'secondary' | 'default';
  variant?: 'contained' | 'outlined' | 'text';
  className?: string;
};

export const ButtonWithArrowLeft: React.FC<ButtonWithArrowType> = ({
  label,
  onClick,
  color = 'primary',
  variant = 'text',
  className,
}) => {
  const { classes } = useStyles();

  return (
    <Button
      className={className}
      color={color}
      variant={variant}
      onClick={onClick}
      startIcon={<ArrowBackSharp color="inherit" />}
    >
      <span className={classes.label}>{label}</span>
    </Button>
  );
};
